import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'mobile-protection-of-personal-data',
  templateUrl: './mobile-protection-of-personal-data.component.html',
  styleUrls: [

  ]
})
export class MobileProtectionOfPersonalDataComponent {
  darkMode = false;
  constructor(private route: ActivatedRoute) {
    try {
      const mode = this.route.snapshot.queryParams["mode"];
      this.darkMode = mode === "0" || mode === 0;
      const darkClass = this.darkMode ? "dark" : "";
      document.documentElement.className = darkClass;
      document.body.className = darkClass;
    } catch (e) {
    }
  }
}
